import React, { useState, useEffect, useContext } from "react";
import { Device_classification_devices_func } from "../../../api/devices/groups/device_classification_devices_func";
import { Groups_func } from "../../../api/devices/groups/groups_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem, TooltipHost } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Toast, ToastTitle, useId, ToastPosition, useToastController, ToastBody, ToastTrigger, Link, Input, Tooltip, Image } from "@fluentui/react-components";
import { PhoneLaptop20Regular, BookNumber20Regular, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, AddSquare20Regular, SlideEraser20Regular, Dismiss16Regular, Open20Regular, FilterAdd20Filled, Info16Filled } from "@fluentui/react-icons";
import { lightTheme, primaryIcon, secondaryIcon, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, timezoneInfo, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import { convertToLocalTimezone, convertUTCToReadableFormat } from "../../../utility/utils";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { GlobalContext } from "../../../hooks/globalContext";
import { ToastComponent } from "../../../components/toast/toast.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { FileDownloadComponent } from "../../../components/fileExport/file.export.component";
import { usePermissionStore } from "../../../Store/permissionStore";
import { Census_func } from "../../../api/devices/census/census_func";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import DialogBox from "../../../components/dialog/dialog.component";
import FileUploadComponent from "../../../components/fileImport/file.import.component";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";

export const DeviceClassificationDevices = () => {

  const [isIconEnabled, setIconEnabled] = useState(false);
  const [isModalIconEnabled, setModalIconEnabled] = useState(false);
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  var tenantName = contextValue.tenantName;
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
  const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [deviceSearchVal, setDeviceSearchVal] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [deleteDevices, setDeleteDevices] = useState(false);
  const [overLayData, setOverLayData] = useState<any>({});
  const [devicesTableData, setDevicesTableData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [addDevices, setAddDevices] = useState<any>(false);
  const [selectedDevices, setSelectedDevices] = useState<any>([]);
  const [isToast, setIsToast] = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [isRefresh, setIsRefresh]: any = useState(false);
  const [devicesOfTenant, setDevicesOfTenant] = useState<any>(null);
  const [devicesData, setDevicesData]: any = useState(null);
  const [selectedValue, setSelectedValue] = useState(0);
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [isfilter, setIsFilter] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [machineStatus, setMachineStatus]: any = useState({});
  const [uniqueOS, setUniqueOS] = useState([]);
  const [isOsName, setOsName] = useState([]);
  const [csvDevicesList, setCsvDevicesList] = useState<any>([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const { permissions } = usePermissionStore();
  const [loading, setLoading] = useState(true);
  const [errorToast, setErrorToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [isOverlayFilter, setIsOverlayFilter] = useState(false);
  const [dropDownValue1Overlay, setDropDownValue1Overlay] = useState<any>();
  const [dropDownValue2Overlay, setDropDownValue2Overlay] = useState<any>();
  const [filterMenuOpenOverlay, setFilterMenuOpenOverlay] = useState(false);
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [filterColumnsData, setFilterColumnsData] = useState([]);
  const [errorMessage, setErrorMessage] = useState<String>('');

  const handleIconActive: any = (data: any) => {
    setIconEnabled(data.target.checked);
  }

  const handleModalIconActive: any = (data: any) => {
    setModalIconEnabled(data.target.checked);
  }

  const handleFilterArray = (): any => {
    const value1 = dropDownValue1
    const value2 = dropDownValue2;
    const result = value1 + " : " + value2;
    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setLoading(true);
    setDropDownValue1('');
    setDropDownValue2('');
  }

  const handleOverlayFilter = (): any => {
    const value1 = dropDownValue1Overlay;
    const value2 = dropDownValue2Overlay;
    const result = value1 + " : " + value2;
    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setIsOverlayFilter(true);
    // setLoading(true);
    setDropDownValue1Overlay('');
    setDropDownValue2Overlay('');
    if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1Overlay} :`))) {
      setErrorMessage(`${dropDownValue1Overlay} is already filtered.`);
      return;
    } else {
      setErrorMessage(''); // Clear the message if no issue
    }
  }

  const handleCloseFilter = (index: any): any => {
    console.log("clicked");
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    !isOverlayFilter && setLoading(true);

    setIsOverlayFilter(false);
  }

  useEffect(() => {
    if (filterArray.length > 0) {
      setResetDisabled(false)
    }
    else {
      setResetDisabled(true)
    }
  }, [filterArray])


  const [messagebar2, setmessagebar2] = useState(false);
  const handleBothSetMessage = () => {
    // setmessagebar1(false);
    setmessagebar2(true);
  };

  const handle = useFullScreenHandle();
  useEffect(() => {
    const operatingSystemName: any = uniqueOS.map((item) => {
      console.log("items", item);
      return {
        key: item,
        label: <Caption1>{item}</Caption1>
      };
    });

    setOsName(operatingSystemName);
    console.table("operatingSystemName test", operatingSystemName);
  }, [uniqueOS])

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9-_]*$/;
    const regexN = /^[0-9.]*$/;
    if (name === 'filter' && dropDownValue1 === ("Operating System") || dropDownValue1 === ("Device Name")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    if (name === 'filter' && dropDownValue1 === ("Nanoheal Version")) {
      if (regexN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    if (name === 'filter' && dropDownValue1 === ("Manufacturer")) {
      if (regexS.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
  }

  const overlayInputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9 ]*$/;
    const regexN = /^[0-9]*$/;
    if (name === 'filter' && dropDownValue1Overlay === ("Device Name")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2Overlay(enteredValue);
      }
    }
  }

  var menuItems: any = [];

  const toasterId = useId();
  const { dispatchToast } = useToastController(toasterId);
  const [position, setPosition] = React.useState<ToastPosition>("top-end");

  const deleteToast = () =>
    dispatchToast(
      <Toast>
        <ToastTitle
          action={
            <ToastTrigger>
              <Link> <Dismiss16Regular /> </Link>
            </ToastTrigger>}
        > Sucess </ToastTitle>
        <ToastBody> Device Classification Chem Factory Worker - 001 is deleted succesfully </ToastBody>
      </Toast>,
      { position, intent: "success" }
    );

  menuItems.push
    (
      <FluentProvider theme={lightTheme}>
        <MenuItem onClick={() => navigate("/manage/devices/device_classification/devices")}
          icon={
            <Stack horizontal tokens={{ childrenGap: 40 }}>
              <StackItem><Text></Text></StackItem>
              <StackItem> <PhoneLaptop20Regular {...primaryIcon} /> </StackItem>
            </Stack>}>
          <Stack tokens={{ childrenGap: 30 }} horizontal>
            <StackItem><Text></Text></StackItem>
            <StackItem> <Caption1> Devices </Caption1> </StackItem>
            <StackItem> <Stack tokens={{ childrenGap: 80 }} horizontal> <StackItem><Text></Text></StackItem> <StackItem><Text></Text></StackItem> </Stack> </StackItem>
            {/* SPACING IN INLINE SIDEBAR */}
          </Stack>
        </MenuItem>
      </FluentProvider>
    );

  menuItems.push
    (
      <MenuItem onClick={() => navigate("/manage/devices/device_classification/scores")}
        icon={
          <Stack horizontal tokens={{ childrenGap: 40 }}>
            <StackItem><Text></Text></StackItem>
            <StackItem> <BookNumber20Regular {...primaryIcon} /> </StackItem>
          </Stack>}>
        <Stack tokens={{ childrenGap: 30 }} horizontal>
          <StackItem><Text></Text></StackItem>
          <StackItem> <Caption1> Scores </Caption1> </StackItem>
        </Stack>
      </MenuItem>
    );

  //inline side menu content code ends here
  var tableColumns: any[] = [];
  var filterColumns: any[] = [];
  useEffect(() => {
    contextValue?.tableColumnsData?.Devices?.Device_Classification_Devices.forEach((val) => {
      if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
        if (val.key === "installation_date_timezoned" || val.key === "last_event_timezoned") {
          tableColumns[val.priority] = ({
            key: val.key,
            label:
              <>
                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                  <StackItem>
                    <Body1Strong>{`${val.name}`}</Body1Strong>
                  </StackItem>
                  <StackItem align="center">
                    <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                      <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                    </Tooltip>
                  </StackItem>
                </Stack>
              </>
          });
        } else {
          tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
        }
      }

      if (val.display.filter.toLocaleLowerCase() === "yes") {
        filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
      }
    });

    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);

    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Devices?.Device_Classification_Devices.filter((val) => val.priority >= 0));

    contextValue.setManageViewPageDetails({ module: "Devices", page: "Device_Classification_Devices" });
  }, [contextValue.tableColumnsData]);

  var overlayColumns = [
    { key: "device_name", label: <Body1Strong> Device Name</Body1Strong> },
    { key: "os", label: <Body1Strong> Operating System  </Body1Strong> },
  ];

  var dropdownData = [
    { key: "op_1", label: <Body1 onClick={() => setSelectedValue(1)}> Choose devices manually </Body1> },
    { key: "op_2", label: <Body1 onClick={() => setSelectedValue(2)}> Upload a CSV containing the Devices </Body1> },
  ];

  var ddData = [
    { key: "op_csv", label: <Body1Strong> CSv File </Body1Strong> },
  ];
  //data table column name code ends here

  // overflow set contents code starts here

  const ActionButton = ({ icon, text, onClick, disabled = false, tooltip }) => (
    tooltip ? (
      <TooltipHost content={tooltip}>
        <Button shape="circular" appearance="subtle" size="small" onClick={onClick} disabled={disabled}>
          <Stack tokens={{ childrenGap: 5 }} horizontal>
            <StackItem>{icon}</StackItem>
            <StackItem><Caption1>{text}</Caption1></StackItem>
          </Stack>
        </Button>
      </TooltipHost>
    ) : (
      <Button shape="circular" appearance="subtle" size="small" onClick={onClick} disabled={disabled}>
        <Stack tokens={{ childrenGap: 5 }} horizontal>
          <StackItem>{icon}</StackItem>
          <StackItem><Caption1>{text}</Caption1></StackItem>
        </Stack>
      </Button>
    )
  );
  const overFlowComponent = {
    data: (
      <>
        {/* Add Devices Button */}
        <StackItem>
          {permissions.includes("all") || permissions.includes("deviceClassification_Fullaccess") ? (
            <ActionButton
              icon={<AddSquare20Regular {...primaryIcon} />}
              text="Create Devices"
              onClick={() => {
                contextValue.setSelectedRowIdInSubTable(selectedDevices);
                setOverlayOpen(true);
              }} tooltip={undefined} />
          ) : (
            <ActionButton
              icon={<AddSquare20Regular {...secondaryIcon} />}
              text="Create Devices"
              disabled
              tooltip="You do not have access" onClick={undefined} />
          )}
        </StackItem>

        <StackItem><Divider vertical /></StackItem>

        {/* Remove Devices Dialog */}
        <StackItem>
          <DialogBox
            headerButton={
              <ActionButton
                icon={<SlideEraser20Regular {...(isIconEnabled ? primaryIcon : secondaryIcon)} />}
                text="Remove Devices"
                onClick={() => { }}
                disabled={!isIconEnabled} tooltip={undefined} />
            }
            content="Are you sure you wish to remove the selected devices from the Device Classification?"
            footer={
              <Stack horizontal tokens={{ childrenGap: 10 }}>
                <StackItem>
                  <Button shape="circular" appearance="primary" onClick={() => setDeleteDevices(true)} size="small">Confirm</Button>
                </StackItem>
                <StackItem>
                  <Button shape="circular" size="small">Cancel</Button>
                </StackItem>
              </Stack>
            }
          />
        </StackItem>

        <StackItem><Divider vertical /></StackItem>

        {/* Refresh and Export Buttons */}
        <Stack tokens={{ childrenGap: 6 }} horizontal>
          <StackItem>
            <ActionButton
              icon={<ArrowClockwise20Regular {...primaryIcon} />}
              text="Refresh"
              onClick={() => { setCurrentPageNo(1); setIsRefresh(true);setLoading(true); }} tooltip={undefined}
              />
          </StackItem>
          <StackItem>
            {permissions.includes("all") || permissions.includes("deviceClassification_Fullaccess") || permissions.includes("deviceClassification_ReadandExport") ? (
              <>
                <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_${contextValue.selectedRowDetails.name}_Details.csv`} />
                <ActionButton
                  icon={<ArrowDownload20Regular {...primaryIcon} />}
                  text="Export"
                  onClick={() => setExportBtnClicked(true)} tooltip={undefined} />
              </>
            ) : (
              <ActionButton
                icon={<ArrowDownload20Regular {...secondaryIcon} />}
                text="Export"
                disabled
                tooltip="You do not have access" onClick={undefined} />
            )}
          </StackItem>
          <StackItem>
            <ActionButton
              icon={<Settings20Regular {...primaryIcon} />}
              text="Manage View"
              onClick={() => document.getElementById("manageView").click()} tooltip={undefined} />
          </StackItem>
        </Stack>

        <StackItem grow shrink>
          <Stack horizontalAlign="end">
            <StackItem grow shrink>
              <FullScreenButton handle={handle} />
            </StackItem>
          </Stack>
        </StackItem>
      </>
    ),
  }
  // overflow set contents code ends here

  useEffect(() => {
    console.log("exportDetails=", exportDetails);

    var tempExportData: any = [];

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      tempExportData.push({
        'Tenant Name': tenantName,
        'Machine Name': val.host,
        'Manufacturer': val?.length > 0 ? JSON.parse(val.value).chassismanufacturer : "-",
        'Machine Operating Sytem': val.os != undefined ? val.os : "-",
        'OS Version': val.osversion,
        'Nanoheal Client Version': val.clientversion,
        'Nanoheal Client installed date': new Date(val.born * 1000).toLocaleString(),
        'Nanoheal client\'s Last event': new Date(val.last * 1000).toLocaleString()
      });
    });

    setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  var tempTableData: any = [];
  var tempExportData: any = [];

  const [dataLength, setDatalenth]: any = useState()

  useEffect(() => {
    console.log("final_data=", final_data);

    if (final_data !== undefined && final_data !== null) {
      const newUniqueOs: any = [];

      final_data.forEach((val: any) => {
        // Ensure the OS name is valid and not already in the list
        if (val.os && val.os.trim() !== "-" && !newUniqueOs.includes(val.os)) {
          newUniqueOs.push(val.os);
        }
      });

      setUniqueOS(newUniqueOs);
      console.log("Unique operating System:", newUniqueOs);
    } else {
      setUniqueOS([]);
    }
  }, [final_data]);

  useEffect(() => {
    // data table values append code starts here

    if (final_data !== undefined && final_data !== null) {
      setDatalenth(final_data?.length);
    }
    var tempVal: any = '"Machines"';
    !isOverlayFilter && final_data !== undefined && final_data !== null ?
      final_data?.map((val: any, i: any) => {
        const operatingSystem = val.os;
        const Operating_System = operatingSystem?.substring(0, 9) + "\n" + operatingSystem?.substring(9, 21) + "\n" + operatingSystem?.substring(21);
        tempVal += "\n" + val.host;

        var deviceStatus: any = Object.keys(machineStatus)?.length > 0 && machineStatus[`${val.host}`]?.length > 0 ? machineStatus[`${val.host}`][0] : 'offline';
        var deviceType: any = Object.keys(machineStatus)?.length > 0 && machineStatus[`${val.host}`]?.length > 0 ? machineStatus[`${val.host}`][1] : 'default';

        var currentIcon = <Badge size="extra-small" appearance="filled" color={deviceStatus === 'online' ? "success" : "informative"} > </Badge>;

        if (deviceStatus === 'online') {
          if (deviceType == 1) {
            currentIcon = <Image src="/Dashboard/image/G_Win.svg" alt="Analyze Icon" />;
          } else if (deviceType == 2) {
            currentIcon = <Image src="/Dashboard/image/G_Android.svg" alt="Analyze Icon" />;
          } else if (deviceType == 5) {
            currentIcon = <Image src="/Dashboard/image/G_Apple.svg" alt="Analyze Icon" />;
          }
        } else if (deviceStatus === 'offline') {
          if (deviceType == 1) {
            currentIcon = <Image src="/Dashboard/image/Windows.svg" alt="Analyze Icon" />;
          } else if (deviceType == 2) {
            currentIcon = <Image src="/Dashboard/image/android.svg" alt="Analyze Icon" />;
          } else if (deviceType == 5) {
            currentIcon = <Image src="/Dashboard/image/apple.svg" alt="Analyze Icon" />;
          }
        }

        {
          permissions.includes("all") || permissions.includes("deviceClassification_Fullaccess") ?
          tempTableData.push({
            id: val.host,
            // checkbox: 'hide',
            device_names: { label: <Caption1> {val.host} </Caption1>, icon: currentIcon, id: `${i}` },
            manufacturer: { label: <Caption1> {val?.length > 0 ? JSON.parse(val.value).chassismanufacturer : "-"} </Caption1>, status: "" },
            os: { label: <Caption1> {Operating_System !== "undefined\nundefined\nundefined" ? Operating_System : "-"} </Caption1> },
            osversion: { label: <Caption1> {val.clientversion} </Caption1> },
            nanoheal_version: { label: <Caption1> {val.clientversion} </Caption1> },
            installation_date: { label: <Caption1> {val.born ? convertUTCToReadableFormat(val.born) : '-'} </Caption1> },
            installation_date_timezoned: { label: <Caption1> {val.born ? convertToLocalTimezone(val.born, userTimeZone) : '-'} </Caption1> },
            last_event: { label: <Caption1> {val.last ? convertUTCToReadableFormat(val.last) : '-'} </Caption1> },
            last_event_timezoned: { label: <Caption1> {val.last ? convertToLocalTimezone(val.last, userTimeZone) : '-'} </Caption1> },
          })
          :
          tempTableData.push({
            id: val.host,
            checkbox: 'hide',
            device_names: { label: <Caption1> {val.host} </Caption1>, icon: currentIcon, id: `${i}` },
            manufacturer: { label: <Caption1> {val.length > 0 ? JSON.parse(val.value).chassismanufacturer : "-"} </Caption1>, status: "" },
            os: { label: <Caption1> {Operating_System !== "undefined\nundefined\nundefined" ? Operating_System : "-"} </Caption1> },
            osversion: { label: <Caption1> {val.clientversion} </Caption1> },
            nanoheal_version: { label: <Caption1> {val.clientversion} </Caption1> },
            installation_date: { label: <Caption1> {val.born ? convertUTCToReadableFormat(val.born) : '-'} </Caption1> },
            installation_date_timezoned: { label: <Caption1> {val.born ? convertToLocalTimezone(val.born, userTimeZone) : '-'} </Caption1> },
            last_event: { label: <Caption1> {val.last ? convertUTCToReadableFormat(val.last) : '-'} </Caption1> },
            last_event_timezoned: { label: <Caption1> {val.last ? convertToLocalTimezone(val.last, userTimeZone) : '-'} </Caption1> },
          })
        }
      }) : (tempTableData = []);

    !isOverlayFilter && (tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]));

    setTimeout(() => {
      !isOverlayFilter && final_data !== undefined && final_data !== null && setLoading(false);
    }, 500);
  }, [final_data, machineStatus, permissions]);
  // data table values append code ends here

  var tempTableData1: any = [];
  useEffect(() => {
    // devices data table values append code starts here

    devicesData !== undefined && devicesData !== null
      ? devicesData?.map((val: any, i: number) => {
        if (!(selectedDevices.includes(val.host)) /*&& !(contextValue.selectedRowIdInSubTable.includes(val.host))*/) {
          tempTableData1.push({
            id: val.host,
            device_name: { label: <Caption1> {val.host} </Caption1>, id: `${i}` },
            os: { label: <Caption1> {val.os} </Caption1>, status: "" },
          });
        }
      }) : (tempTableData1 = []);

    tempTableData1.length > 0 ? setDevicesTableData(tempTableData1) : setDevicesTableData([]);
  }, [devicesData, selectedDevices]);
  // devices data table values append code ends here

  //overlay code starts here
  useEffect(() => {
    var defaultSelected: any = [];

    setOverLayData({
      size: "large",
      isTabs: false,

      headerTitle:
        (
          <>
            <FluentProvider theme={dashboardTheme}>
              <Title3> Create Devices </Title3>
            </FluentProvider>
          </>
        ),

      tabItems: {},

      bodyData:
        (
          <>
            <FluentProvider theme={dashboardTheme}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem>
                  <Stack tokens={{ childrenGap: 10 }}>
                    <StackItem> <Body1> How you would like to add machines to this Device Classification? </Body1> </StackItem>
                    <StackItem>
                      <DropdownComponent optionData={dropdownData} setDropDownValue={setDropDownValue1} dropDownvalue={dropDownValue1} />
                    </StackItem>
                    <StackItem>
                      {selectedValue === 1 &&
                        <>
                          <FluentProvider theme={dashboardTheme}>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                              <StackItem>
                                <Stack tokens={{ childrenGap: 10 }}>
                                  <InfoBar title={"Try changing or adding filters if you don't see what you're looking for."} />
                                  <StackItem>
                                    <Stack wrap horizontal tokens={{ childrenGap: 20 }}>
                                      {/* <SearchBar columnSearch={"for Device Name"} searchVal={searchVal} setSearchVal={setSearchVal} /> */}
                                      <StackItem>
                                        <SearchBar columnSearch={"for Device Name"} searchVal={deviceSearchVal} setSearchVal={setDeviceSearchVal} disabled={loading || devicesTableData.length === 0} />
                                      </StackItem>
                                      <StackItem>
                                        <MenuDropdown open={filterMenuOpenOverlay} btn={
                                          <MenuButton disabled={loading || devicesTableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpenOverlay(true)}>
                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                              <FilterAdd20Filled {...primaryIcon} />
                                              <Body1> Filter </Body1>
                                            </Stack>
                                          </MenuButton>
                                        } itemVal={
                                          <>
                                            <Body1Strong> Add a Filter </Body1Strong>
                                            <Divider />
                                            <MenuList>
                                              <Stack tokens={{ childrenGap: 5 }}>
                                                <StackItem> <Text></Text> </StackItem>
                                                <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                                <DropdownComponent optionData={overlayColumns} setDropDownValue={setDropDownValue1Overlay} dropDownvalue={dropDownValue1Overlay} />
                                                <StackItem> <Divider /> </StackItem>
                                                <StackItem> <Caption1> Value </Caption1> </StackItem>
                                                {dropDownValue1Overlay === "Operating System" && <DropdownComponent optionData={isOsName} setDropDownValue={setDropDownValue2Overlay} dropDownvalue={dropDownValue2Overlay} />}
                                                {dropDownValue1Overlay === "Device Name" && <Input size='small' onChange={overlayInputChange} name="filter" value={dropDownValue2Overlay} />}
                                                <StackItem>
                                                  <Divider />
                                                </StackItem>
                                                <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                  <StackItem>
                                                    <Button shape="circular" appearance="primary" onClick={() => { handleOverlayFilter(); setFilterMenuOpenOverlay(false) }}
                                                      disabled={dropDownValue2Overlay == undefined || dropDownValue2Overlay?.length === 0 || dropDownValue1Overlay == undefined || dropDownValue1Overlay?.length === 0 || filterArray.includes(`${dropDownValue1Overlay}:`) ? true : false}>
                                                      <Caption1> Apply </Caption1>
                                                    </Button>
                                                  </StackItem>
                                                  <StackItem>
                                                    <Button shape="circular" onClick={() => setFilterMenuOpenOverlay(false)}>     <Caption1> Cancel </Caption1>
                                                    </Button>
                                                  </StackItem>
                                                </Stack>
                                              </Stack>
                                            </MenuList>
                                          </>}
                                        />
                                      </StackItem>
                                      <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                        <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                          <Stack tokens={{ childrenGap: 5 }} horizontal>
                                            <StackItem> <FilterDismiss20Filled /> </StackItem>
                                            <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                          </Stack>
                                        </Button>
                                      </StackItem>
                                      <StackItem>
                                        {filterArray.length > 0 && filterArray.map((item, index) => (
                                          <Button shape="circular" size="small">
                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                              <StackItem> {item} </StackItem>
                                              <StackItem>
                                                <Stack tokens={{ childrenGap: 1 }}>
                                                  <StackItem><Text></Text></StackItem>
                                                  <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                                </Stack>
                                              </StackItem>
                                            </Stack>
                                          </Button>
                                        ))}
                                      </StackItem>
                                    </Stack>
                                  </StackItem>

                                  <StackItem>
                                    <Stack tokens={{ childrenGap: 10 }}>
                                      <FluentProvider theme={dashboardTheme}>
                                        {devicesTableData.length > 0 ? (
                                          <DataTable
                                            tableData={devicesTableData}
                                            columns={overlayColumns}
                                            isSubTable={true}
                                            defaultSelected={defaultSelected}
                                          />)
                                          : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                                      </FluentProvider>
                                    </Stack>
                                  </StackItem>
                                </Stack>
                              </StackItem>

                            </Stack>
                          </FluentProvider>
                        </>
                      }

                      {selectedValue === 2 &&
                        <>
                          <Stack tokens={{ childrenGap: 15 }}>
                            <StackItem><Text></Text></StackItem>
                            <StackItem> <Body1Strong> Steps to create the CSV group </Body1Strong> </StackItem>
                            <StackItem> <Body1> 1. Download the file that contains the list of devices </Body1> </StackItem>
                            <Stack tokens={{ childrenGap: 10 }} horizontal>
                              <StackItem><Text></Text></StackItem>
                              <StackItem><FileDownloadComponent data={"Machines\n" + devicesData?.map((val: any) => `${val.host}`).join("\n")} fileName="devices_list" /> </StackItem>
                            </Stack>
                            <Stack>
                              <StackItem> <Body1> 2. Revise device grouping in the CSV. </Body1> </StackItem>
                              <StackItem>
                                <Stack tokens={{ childrenGap: 15 }} horizontal>
                                  <StackItem><Text></Text></StackItem>
                                  <StackItem>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      <StackItem> <Caption1> Watch the instructional video for guidance </Caption1> </StackItem>
                                      <StackItem> <Open20Regular /> </StackItem>
                                    </Stack>
                                  </StackItem>
                                </Stack>
                              </StackItem>
                            </Stack>

                            <StackItem> <Body1> 3. Upload your .csv file </Body1> </StackItem>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                              <StackItem><Text></Text></StackItem>
                              <StackItem>
                                {/* <DropdownComponent optionData={ddData} setDropDownValue = {setDropDownValue1} dropDownvalue = {dropDownValue1}/> */}
                                <FileUploadComponent setDeviceList={setCsvDevicesList} />
                              </StackItem>
                            </Stack>

                            {devicesOfTenant != null && csvDevicesList.length > 0 && selectedTableData.length > 0 && <><StackItem><Text>{selectedTableData.length} unique machine found.</Text> </StackItem>
                              <StackItem><Text>Kindly check the group names and confirm that everything is exactly the way you need them. If you have made any mistake,Kindly make the changes and upload the CSV with the corrections</Text></StackItem></>}

                            {devicesOfTenant != null && csvDevicesList.length > 0 && selectedTableData.length == 0 && <StackItem><Text>No unique machine found</Text></StackItem>}
                          </Stack>
                        </>
                      }
                    </StackItem>
                  </Stack>
                </StackItem>

                {selectedValue === 1 &&
                  <>
                    <Divider vertical />
                    <StackItem>
                      {(contextValue.selectedRowIdInSubTable.length >= 0 || selectedTableData.length >= 0) && <StackItem>
                        <Stack horizontal>
                          {/* <Label> <Body1Strong> Selected </Body1Strong> </Label> */}
                          <StackItem>
                            <DataTable tableData={selectedTableData} columns={[{ key: "selected", label: <Body1Strong> Selected ({contextValue.selectedRowIdInSubTable.length})</Body1Strong> }]} />
                          </StackItem>
                        </Stack>
                      </StackItem>}
                    </StackItem>
                  </>

                }
              </Stack>
            </FluentProvider>
            {/* THIS SHOULD BE FETCHED FROM THE BACKEND */}
          </>
        ),

      footerData:
        (
          <>
            {selectedValue === 1 ?
              <Button shape="circular" appearance="primary" disabled={(contextValue.selectedRowIdInSubTable?.length > 0) ? false : true} onClick={() => { setAddDevices(true); }} >Submit</Button>
              : selectedValue === 2 ?
                <Button shape="circular" appearance="primary" disabled={(devicesOfTenant != null && csvDevicesList.length > 0 && selectedTableData.length > 0) ? false : true} onClick={() => { setAddDevices(true); }} >Submit</Button>
                : <Button shape="circular" appearance="primary" disabled={true} >Submit</Button>
            }
          </>
        ),
    });
  }, [devicesTableData, selectedValue, selectedTableData, dropDownValue1Overlay, dropDownValue2Overlay, filterMenuOpenOverlay, filterArray, isfilter]);
  //overlay code ends here

  var validDevicesList: any = [];
  var inValidDevicesList: any = [];
  var alldDevicesList: any = [];
  useEffect(() => {
    if (csvDevicesList.length > 0 && devicesOfTenant != null) {
      validDevicesList = [];
      inValidDevicesList = [];
      alldDevicesList = [];

      devicesOfTenant.map((val: any) => {
        alldDevicesList.push(val.host);
      });

      csvDevicesList.map((val: any) => {
        var deviceName = val.replace(/[\r\n]/g, '');
        alldDevicesList.includes(deviceName) ? validDevicesList.push(deviceName) : inValidDevicesList.push(deviceName);
      });

      validDevicesList.length > 0 ? setSelectedTableData(validDevicesList) : setSelectedTableData([]);

      contextValue.setSelectedRowIdInSubTable(validDevicesList);
    }
  }, [devicesOfTenant, csvDevicesList]);

  useEffect(() => {
    !overlayOpen && setSelectedValue(0);
    !overlayOpen && setFilterArray([]);
    !overlayOpen && setDeviceSearchVal('');
    console.log("Overlay closed. Resetting selectedValue to 0");
  }, [overlayOpen]);

  useEffect(() => {
    !deleteDevices && contextValue.setSelectedRowIdInTable([]);
    !deleteDevices && contextValue.setSelectedRowIdInSubTable([]);
  }, [deleteDevices]);

  useEffect(() => {
    var newSelectedValues = selectedDevices.concat(contextValue.selectedRowIdInSubTable);
    const uniqueSet = new Set(newSelectedValues);
    const resultArray = Array.from(uniqueSet);

    contextValue.setSelectedRowIdInSubTable(resultArray);
  }, [selectedDevices]);

  var dataArr: any = [];
  useEffect(() => {
    contextValue.selectedRowIdInSubTable.map((val: any, i: any) => {
      dataArr.push({
        id: i,
        checkbox: "hide",
        selected: { label: <Caption1> {val} </Caption1>, id: `${i}` },
      });
    });

    dataArr.length > 0 ? setSelectedTableData(dataArr) : setSelectedTableData([]);

    (contextValue.selectedRowIdInTable.length && dataLength !== contextValue.selectedRowIdInTable.length) ? setIconEnabled(true) : setIconEnabled(false);
  }, [contextValue.selectedRowIdInTable, dataLength, contextValue.selectedRowIdInSubTable]);

  useEffect(() => {
    const props: any = {
      setDevicesData: setDevicesData,
      deviceSearchVal: deviceSearchVal,
      selectedRowIdInTable: [],
      tenant: tenantName,
      overlayOpenNew: true,
      classificationName: 'demo',
      setDevicesOfTenant: setDevicesOfTenant,
      csvDevicesList: csvDevicesList,
      configGroupBtnCliked: false,
      devicesOfTenant: devicesOfTenant,
    };

    overlayOpen && ((selectedValue === 2 && devicesOfTenant === null && csvDevicesList.length > 0) || devicesData == undefined || devicesData === null || deviceSearchVal?.length > 0) && Groups_func(props);
  }, [selectedValue, deviceSearchVal, csvDevicesList]);

  useEffect(() => {
    const tempName = localStorage.getItem('classificationName');
    const classificationName = (tempName != undefined && tempName.length > 0) ? tempName : contextValue.selectedRowDetails.name;

    const props: any = {
      selectedRowIdInTable: contextValue.selectedRowIdInTable,
      selectedRowIdInSubTable: contextValue.selectedRowIdInSubTable,
      tenant: tenantName,
      setSelectedDevices: setSelectedDevices,
      classificationName: classificationName,
      addDevices: addDevices,
      setAddDevices: setAddDevices,
      setToastMessage: setToastMessage,
      setErrorToast: setErrorToast,
      setOverlayOpen: setOverlayOpen,
      selectedValue: selectedValue,
      setIsToast: setIsToast,
      devicesOfTenant: devicesOfTenant,
      selectedDevices: selectedDevices,
      //setDevicesOfTenant: setDevicesOfTenant,
      deleteDevices: deleteDevices,
      setDeleteDevices: setDeleteDevices,
    };

    (overlayOpen && ((selectedValue === 1 && selectedDevices?.length === 0) || addDevices) || deleteDevices) && Device_classification_devices_func(props);
  }, [selectedValue, addDevices, deleteDevices]);

  return (
    <>
    <FullScreen handle={handle} className="fullScreenBackgroundColor">
      <StackItem grow shrink style={BreadcrumbsBorder}>
        <Stack tokens={{childrenGap:10}} horizontal>
          <StackItem grow shrink>
            <Stack tokens={{childrenGap:5}} horizontalAlign="start">
            <StackItem><Text></Text></StackItem>
              <StackItem grow shrink> 
                {/* <Breadcrumbs pageName="Devices" subPageName="Device Classification" subPageLink="/manage/devices/device_classification" /> */}
                <Breadcrumbs 
                  items={[
                    { name: "Manage", link: "/home" },
                    { name: "Devices", link: "/manage/devices/overview" },
                    { name: "Device Classification", link: "/manage/devices/device_classification" },
                    { name: localStorage.getItem('classificationName'), link: "#", isData: true },
                    { name: "Devices", link: "#" }
                  ]} 
                />
                </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            <Stack tokens={{ childrenGap: 10 }} horizontal style={DynamicBoxingCSS}>
              <StackItem style={DynamicBoxingCSS}>
                {/* pages code starts here */}
                <Stack style={DynamicBoxingCSS}>
                  <Stack tokens={{ childrenGap: 25 }} horizontal>
                    <StackItem><Text></Text></StackItem>
                    <StackItem>
                      <FluentProvider theme={dashboardTheme}>
                        {/* <Title3> {localStorage.getItem('classificationName')} | Devices </Title3> */}
                      </FluentProvider>
                    </StackItem>
                  </Stack>
                  <FluentProvider style={parentHome} theme={dashboardTheme}>
                    <Stack style={parentHome} horizontal >
                      {/* SPACING BETWEEN INLINE AND PAGE */}
                      <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={menuItems} />
                      <StackItem style={DynamicBoxingCSS}>
                        <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                          <StackItem>
                            <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                            <Divider />
                          </StackItem>
                          <StackItem>
                            <StackItem style={wraperStyle}>
                              <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                  <StackItem>
                                    <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Devices"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                                  </StackItem>
                                  <StackItem>
                                    <MenuDropdown open={filterMenuOpen} btn={
                                      <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                          <FilterAdd20Filled {...primaryIcon} />
                                          <Body1> Filter </Body1>
                                        </Stack>
                                      </MenuButton>
                                    } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                      <Divider />
                                      <MenuList>
                                        <Stack tokens={{ childrenGap: 5 }}>
                                          <StackItem> <Text></Text> </StackItem>
                                          <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                          {/* <DropdownComponent optionData={columns1} setDropDownValue = {setDropDownValue1} dropDownvalue = {dropDownValue1} /> */}
                                          <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                          <StackItem> <Divider /> </StackItem>
                                          <StackItem> <Caption1> Value </Caption1> </StackItem>
                                          {(dropDownValue1 === 'Installation Date' || dropDownValue1 === 'Latest Event') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                          {dropDownValue1 === "Operating System" && <DropdownComponent optionData={isOsName} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
                                          {(dropDownValue1 === "Device Name" || dropDownValue1 === "Manufacturer" || dropDownValue1 === "Nanoheal Version") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                          <StackItem> <Divider /> </StackItem>
                                          <Stack tokens={{ childrenGap: 10 }} horizontal>
                                            <StackItem>
                                              <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                                disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                                <Caption1> Apply </Caption1>
                                              </Button>
                                            </StackItem>

                                            <StackItem>
                                              <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                                <Caption1> Cancel </Caption1>
                                              </Button>
                                            </StackItem>
                                          </Stack>
                                        </Stack>
                                      </MenuList>
                                    </>} />
                                  </StackItem>
                                  <StackItem onClick={() => { setIsOverlayFilter(false); setFilterArray([]); setIsFilter(false); setDropDownValue2Overlay(''); setResetDisabled(true); }}>
                                    <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> <FilterDismiss20Filled /> </StackItem>
                                        <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                      </Stack>
                                    </Button>
                                  </StackItem>
                                </Stack>
                                {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                              </Stack>
                              <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                                <StackItem>
                                  {filterArray.length > 0 &&
                                    // <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                                    <Stack wrap horizontal >
                                      {filterArray.length > 0 && filterArray.map((item, index) => (
                                        <Button shape="circular" size="small">
                                          <Stack tokens={{ childrenGap: 5 }} horizontal>
                                            <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                            <StackItem>
                                              <Stack tokens={{ childrenGap: 1 }}>
                                                <StackItem><Text></Text></StackItem>
                                                <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                              </Stack>
                                            </StackItem>
                                          </Stack>
                                        </Button>
                                      ))}
                                      {/* </Stack> */}
                                    </Stack>}
                                </StackItem>

                                <StackItem disableShrink>
                                  {(tableData.length > 0 && !loading) && (
                                    totalRecords > 0 &&
                                    <Caption1>
                                      Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                    </Caption1>
                                  )}
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </StackItem>

                          {/* <Device_classification_devices_func filterArray={filterArray} data={final_data} func={set_final_data} searchVal={searchVal} pageNo = {(currentPageNo - 1) * 10} setTotalPages = {setTotalPages} setTotalRecords={setTotalRecords} isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} setDeleteDevices={setDeleteDevices} deleteDevices={deleteDevices} setDevicesData={setDevicesData} setSelectedDevices={setSelectedDevices} addDevices={addDevices} setAddDevices={setAddDevices} setIsToast={setIsToast} isRefresh={isRefresh} setIsRefresh={setIsRefresh} setRefreshToast={setRefreshToast} setOverlayOpen={setOverlayOpen} setExportDetails={setExportDetails}  /> */}

                          <Census_func func={set_final_data} data={final_data} setDevicesOfTenant={setDevicesOfTenant} pageNo={(currentPageNo - 1) * 50} setTotalRecords={setTotalRecords} setTotalPages={setTotalPages} setMachineStatus={setMachineStatus} pageName="device_classification" searchVal={searchVal} isFilter={isfilter} setIsFilter={setIsFilter} filterArray={filterArray} isRefresh={isRefresh} setIsRefresh={setIsRefresh} setRefreshToast={setRefreshToast} setExportBtnClicked={setExportBtnClicked} exportBtnClicked={exportBtnClicked} setExportDetails={setExportDetails} />

                          {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                        </Stack>
                      </StackItem>
                    </Stack>
                  </FluentProvider>
                </Stack>
                <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={overLayData} />
              </StackItem>
            </Stack>
          </StackItem>

          {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={addDevices ? "New Devices Added Successfully" : "Devices Removed Successfully"} footer="" />}

          {errorToast && (<ToastComponent setmessagebar={setErrorToast} toastIntent="error" position="top-end" title="Failed" message={toastMessage} footer="" />)}

          {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}

          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>
    </>
  );
};